export const baseData = {
  title: "PAYMENT TERM VENDOR"
}